var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[(_vm.logoLink)?_c('div',{class:_vm.$style.logoImage,style:(_vm.getStyle)}):_c('div',{class:_vm.$style.logoEmpty,domProps:{"textContent":_vm._s(_vm.logoEmptyText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }